import React from "react";
import { Container } from "reactstrap";
import Footer from "../Footer";
import Navi from "../Navi";

const Franchising = () => {
  return (
    <div id="franchising">
      <Navi />
      <Container className="my-5 text-center">
        <h3>BU XİDMƏTİMİZ  BARƏDƏ GƏLƏCƏKDƏ DAHA GENİŞ MƏLUMATLAR  VERİLƏCƏKDİR</h3>
      </Container>
      <Footer />
    </div>
  );
};

export default Franchising;
